import { ReportsView } from '../features/reports';

function Reports() {
  return <ReportsView />;
}

export default Reports;
